














































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Mutation, Action, Getter } from 'vuex-class';

@Component({})
export default class ToolGroup extends Vue {
  @Prop() private rocketGlobal: any;
  @Prop() private rocketComps: any;
  @Mutation('DELETE_COMPS_GROUP') private DELETE_COMPS_GROUP: any;
  @Mutation('ADD_COMPS_GROUP') private ADD_COMPS_GROUP: any;
  @Action('MIXHANDLE_CHANGE_GROUP') private MIXHANDLE_CHANGE_GROUP: any;
  @Action('MIXHANDLE_GET_OPTION') private MIXHANDLE_GET_OPTION: any;
  @Getter('durationTime') private durationTime: any;
  private name: string = '';
  private type: string = 'service';
  private show: boolean = false;
  private template: boolean = false;
  private get compType() {
    return this.rocketComps.tree[this.rocketComps.group].type;
  }
  private handleOption(index: any) {
    this.MIXHANDLE_CHANGE_GROUP(index);
    return this.MIXHANDLE_GET_OPTION({compType: this.compType, duration: this.durationTime});
  }
  private handleHide() {
    this.name = '';
    this.type = 'service';
    this.show = false;
  }
  private handleCreate() {
    let template = 'nouse';
    if (this.type === 'service') {
      template = 'groupService';
    }
    if (this.type === 'database') {
      template = 'groupDatabase';
    }
    if (!this.template) {
      template = 'nouse';
    }
    this.ADD_COMPS_GROUP({name: this.name, type: this.type, template });
    this.handleHide();
    this.template = false;
  }
}
